$ const loadingItems = new Array(5).fill("");

<ul class="items-left-rail-loading" data-testid="items-left-rail-loading">
  <for|_value, index| of=loadingItems>
    <li class="left-rail-item" key=String(`loading-left-rail-item-${index}`)>
      <div class="left-rail-item-image-container">
        <ebay-skeleton style={ height: "123px", width: "123px" }>
          <ebay-skeleton-image/>
        </ebay-skeleton>
      </div>
      <div class="left-rail-item-content-container">
        <div class="left-rail-item-title">
          <ebay-skeleton>
            <ebay-skeleton-text style={ width: "180px" }/>
          </ebay-skeleton>
        </div>
        <div class="left-rail-item-details">
          <ebay-skeleton>
            <ebay-skeleton-text style={ width: "120px", marginTop: "8px" }/>
          </ebay-skeleton>
        </div>
        <div class="left-rail-item-price">
          <ebay-skeleton>
            <ebay-skeleton-text style={ width: "110px" }/>
          </ebay-skeleton>
        </div>
        <div class="left-rail-item-distance">
          <ebay-skeleton>
            <ebay-skeleton-text style={ width: "120px", marginTop: "8px" }/>
          </ebay-skeleton>
        </div>
      </div>
    </li>
  </for>
</ul>
